/* ==========================================================================
   BOS Tuning — Blog
   1) Live-Suche auf der Blog-Uebersicht (filtert die gerenderten Karten)
   2) Inhaltsverzeichnis + Scrollspy auf der Artikelseite
   3) Lesefortschritt + Teilen
   ========================================================================== */
(function () {
  'use strict';

  var norm = function (s) {
    return (s || '')
      .toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  };

  /* ---------- 1) Blog-Suche ---------------------------------------------- */
  function initSearch(root) {
    var input = root.querySelector('[data-blog-search]');
    var grid = root.querySelector('[data-blog-grid]');
    if (!input || !grid) return;

    var items = Array.prototype.slice.call(grid.querySelectorAll('[data-blog-item]'));
    var empty = root.querySelector('[data-blog-empty]');
    var count = root.querySelector('[data-blog-count]');
    var heading = root.querySelector('[data-blog-grid-title]');
    var headingText = heading ? heading.textContent : '';
    var clear = root.querySelector('[data-blog-clear]');
    var searchAll = root.querySelector('[data-blog-searchall]');
    var searchAllBase = searchAll ? searchAll.getAttribute('href') : null;

    function apply() {
      var q = norm(input.value);
      var terms = q ? q.split(' ').filter(Boolean) : [];
      var hits = 0;

      items.forEach(function (el) {
        var hay = el.getAttribute('data-search') || '';
        var match = terms.every(function (t) { return hay.indexOf(t) !== -1; });
        el.hidden = !match;
        if (match) hits++;
      });

      root.classList.toggle('is-searching', terms.length > 0);
      if (empty) empty.hidden = !(terms.length > 0 && hits === 0);
      if (count) {
        count.hidden = terms.length === 0;
        count.textContent = hits === 1 ? '1 Artikel gefunden' : hits + ' Artikel gefunden';
      }
      if (heading) heading.textContent = terms.length ? 'Suchergebnisse' : headingText;
      if (clear) clear.hidden = terms.length === 0;
      if (searchAll && searchAllBase) {
        // Die Live-Suche filtert nur die gerenderten Karten. Wer hier nichts
        // findet, kommt mit einem Klick in die Shop-Suche ueber alle Artikel.
        searchAll.href = searchAllBase.replace('?type=article',
          '?q=' + encodeURIComponent(input.value.trim()) + '&type=article');
      }
    }

    input.addEventListener('input', apply);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { input.value = ''; apply(); }
    });
    if (clear) clear.addEventListener('click', function () { input.value = ''; apply(); input.focus(); });
    root.addEventListener('submit', function (e) { e.preventDefault(); apply(); });
    apply();
  }

  /* ---------- 2) Inhaltsverzeichnis -------------------------------------- */
  function initToc(root) {
    var content = root.querySelector('[data-article-content]');
    var toc = root.querySelector('[data-article-toc]');
    var list = root.querySelector('[data-article-toc-list]');
    if (!content || !toc || !list) return;

    var heads = Array.prototype.slice.call(content.querySelectorAll('h2'));
    if (heads.length < 3) { toc.hidden = true; return; }

    var links = [];
    heads.forEach(function (h, i) {
      if (!h.id) {
        var base = norm(h.textContent).replace(/\s+/g, '-').slice(0, 48) || 'abschnitt';
        h.id = base + '-' + (i + 1);
      }
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.replace(/\s+/g, ' ').trim();
      li.appendChild(a);
      list.appendChild(li);
      links.push(a);
    });

    if (!('IntersectionObserver' in window)) return;
    var seen = {};
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { seen[en.target.id] = en.isIntersecting ? en.intersectionRatio : 0; });
      var best = null;
      heads.forEach(function (h) {
        if (h.getBoundingClientRect().top - 140 <= 0) best = h.id;
      });
      if (!best && heads.length) best = heads[0].id;
      links.forEach(function (a) {
        a.classList.toggle('is-active', a.getAttribute('href') === '#' + best);
      });
    }, { rootMargin: '-120px 0px -70% 0px', threshold: [0, 1] });
    heads.forEach(function (h) { obs.observe(h); });
  }

  /* ---------- 3) Lesefortschritt ----------------------------------------- */
  function initProgress(root) {
    var bar = root.querySelector('[data-article-progress]');
    var content = root.querySelector('[data-article-content]');
    if (!bar || !content) return;
    var tick = function () {
      var rect = content.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      var done = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : (rect.top < 0 ? 1 : 0);
      bar.style.width = (done * 100).toFixed(1) + '%';
    };
    tick();
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick);
  }

  /* ---------- 4) Teilen --------------------------------------------------- */
  function initShare(root) {
    var copy = root.querySelector('[data-article-copy]');
    if (!copy) return;
    copy.addEventListener('click', function () {
      var url = copy.getAttribute('data-url') || window.location.href;
      var done = function () {
        var old = copy.querySelector('span').textContent;
        copy.querySelector('span').textContent = 'Link kopiert';
        setTimeout(function () { copy.querySelector('span').textContent = old; }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done, function () {});
      } else {
        var t = document.createElement('textarea');
        t.value = url; document.body.appendChild(t); t.select();
        try { document.execCommand('copy'); done(); } catch (e) {}
        document.body.removeChild(t);
      }
    });

    var native = root.querySelector('[data-article-native-share]');
    if (native) {
      if (!navigator.share) { native.hidden = true; return; }
      native.addEventListener('click', function () {
        navigator.share({
          title: native.getAttribute('data-title') || document.title,
          url: native.getAttribute('data-url') || window.location.href
        }).catch(function () {});
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-bos-blog]').forEach(initSearch);
    document.querySelectorAll('[data-bos-article]').forEach(function (root) {
      initToc(root);
      initProgress(root);
      initShare(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
